import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import { FAILURE_ALL_LANDINGPAGES, REQUEST_ALL_LANDINGPAGES, SUCCESS_ALL_LANDINGPAGES } from './actions';

/* Landingpages */
export function landingpagesReducerAdmin(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ALL_LANDINGPAGES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ALL_LANDINGPAGES: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ALL_LANDINGPAGES:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
